import {
  PdfFeature,
  PdfPage,
} from 'services/APIs/InternalAPI/internal-api.contracts'

export const QF_Events = {
  PDFViewerLoaded: 'PDFViewerLoaded',
  PDFHighlightClicked: 'PDFHighlightClicked',
  PDFHighlightDoubleClicked: 'PDFHighlightDoubleClicked',
}

export type QF_EventsArgs = {
  PDFViewerLoaded: {
    /**
     * isLoading is used to control when the zoom and pan fix should be applied
     * -1 means src changed and we are waiting for the image to load
     * 0 means image is loading actually loading
     * 1 means image is loaded
     */
    isLoading: -1 | 0 | 1
    imgSrc: string
  }
  PDFHighlightClicked: {
    featureId: string
    pdfPage: PdfPage
    pdfFeature: PdfFeature
  }
  PDFHighlightDoubleClicked: {
    pdfFeature: PdfFeature
  }
}
